import {FontItem} from '~/common/fabric/CreateDesign/components/CardEditor/actions/Dropdown/FontItem/FontItem';
import {RECOMMENDED_FONTS} from '~/common/fabric/CreateDesign/constants';

export function AllFonts({onClick, selectedFont}) {
  return window.fonts
    .filter((font) => !RECOMMENDED_FONTS.some((rf) => rf.family === font.family))
    .map((option) => (
      <FontItem
        font={option}
        key={option.family}
        onClick={onClick}
        selected={option.family === selectedFont?.family}
      />
    ));
}
